import { ModalRef, SprintSectionData } from 'constants/WorkingModePathwaysConstants'

import { PathwayAgendaDetailButtons } from './PathwayAgendaDetailButtons'
import { renderSegments } from './renderSegments'
import { SprintDayCard } from './SprintDayCard'

interface SprintSectionProps {
  data: SprintSectionData
  onOpenModal: (ref: ModalRef) => void
}

export const SprintSection = ({ data, onOpenModal }: SprintSectionProps) => (
  <div className="flex flex-col gap-6 items-center w-full">
    <p className="subtitle-xl w-full">
      {data.title} ({data.durationLabel})
    </p>
    <div className="flex gap-6 items-start w-full">
      {data.paragraphColumns.map((paragraph, index) => (
        <p key={index} className="body-s flex-1 min-w-0">
          {renderSegments(paragraph)}
        </p>
      ))}
    </div>
    <div className="pathway-divider" />
    <div className="flex flex-col gap-4 items-center w-full">
      <div className={data.layout === 'grid' ? 'pathway-day-card-grid' : 'flex flex-wrap gap-4 items-stretch w-full'}>
        {data.dayCards.map(card => (
          <SprintDayCard key={card.key} card={card} onOpenModal={onOpenModal} />
        ))}
      </div>
      {data.sharedActions && <PathwayAgendaDetailButtons actions={data.sharedActions} onOpen={onOpenModal} />}
    </div>
  </div>
)
